import PropTypes from 'prop-types';
import merge from 'lodash/merge';

import Chart from '../../charts/Chart';

import { columnStackChartConfiguration } from './utilities/helpers';

const ColumnStackChart = ({ series, xAxis, yAxis, ...props }) => {
  return (
    <Chart
      options={merge({}, columnStackChartConfiguration, {
        series,
        type: 'column',
        xAxis,
        yAxis,
        ...props,
      })}
      {...props}
    />
  );
};

ColumnStackChart.propTypes = {
  series: PropTypes.array,
  xAxis: PropTypes.object,
  yAxis: PropTypes.object,
};

export default ColumnStackChart;
